import { PILLARS } from "../../data/ybf/pillars";
import { fmtInt, pct } from "../../data/ybf/utils";
import { CheckCircle2, AlertCircle, Clock } from "lucide-react";

export default function TargetProgress({ target }) {
  const p = PILLARS.find((x) => x.id === target.pillar);
  const progress = pct(target.actual, target.target);
  const onTrack = progress >= 80;
  const atRisk = progress >= 50 && progress < 80;
  const behind = progress < 50;
  const status = onTrack ? { label: "On track", icon: CheckCircle2, color: "text-green-700 bg-green-50" }
              : atRisk  ? { label: "At risk",   icon: AlertCircle, color: "text-amber-700 bg-amber-50" }
              :           { label: "Behind",    icon: Clock,       color: "text-red-700 bg-red-50" };
  const StatusIcon = status.icon;

  const formattedActual = target.unit === "%" ? `${target.actual}%` : fmtInt(target.actual);
  const formattedTarget = target.unit === "%" ? `${target.target}%` : fmtInt(target.target);

  return (
    <div
      data-testid={`target-${target.id}`}
      className="bg-white rounded-xl border border-slate-200 p-4 hover:shadow-md transition-shadow"
    >
      <div className="flex items-start justify-between mb-2">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            {p && (
              <span
                className="text-[9px] uppercase tracking-wider font-bold px-1.5 py-0.5 rounded"
                style={{ color: p.color, backgroundColor: `${p.color}10` }}
              >
                {p.short} · {p.name.split(" ")[0]}
              </span>
            )}
            <span className="text-[10px] text-slate-500">By {target.targetYear}</span>
          </div>
          <p className="text-sm font-semibold text-slate-900 leading-snug">{target.label}</p>
        </div>
        <span className={`inline-flex items-center gap-1 text-[10px] font-bold px-2 py-1 rounded-full whitespace-nowrap ${status.color}`}>
          <StatusIcon size={11} />
          {status.label}
        </span>
      </div>

      <div className="mt-4">
        <div className="flex items-baseline justify-between mb-1.5">
          <span className="text-2xl font-bold text-slate-900">{formattedActual}</span>
          <span className="text-xs text-slate-500">of {formattedTarget} {target.unit !== "%" ? target.unit : ""}</span>
        </div>
        <div className="h-2 rounded-full bg-slate-100 overflow-hidden">
          <div
            className="h-full rounded-full transition-all duration-700"
            style={{
              width: `${Math.min(progress, 100)}%`,
              background: p?.color || "#1A1A1A",
            }}
          />
        </div>
        <div className="flex items-center justify-between mt-1">
          <span className="text-[10px] text-slate-500">{progress}% complete</span>
          {progress >= 100 && <span className="text-[10px] font-semibold text-green-700">✓ Achieved</span>}
        </div>
      </div>
    </div>
  );
}
